import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from '../../../core/data/redux/store';
import { Drawer, message, Select } from 'antd';
import DeleteModal1 from '../../../core/modals/deleteModal1';
import { createDeduction, deleteDeduction, fetchDeductions, updateDeduction } from '../../../core/data/redux/payroll/payrollComponent/deduction/deductionActions';

const DeductionModal: React.FC<any> = ({ handleCancel, isModalVisible, modalType, selectedRowData, deductionData, setDeductionData, setTableKey, setIsDeleteModalVisible, isDeleteModalVisible }) => {
    const dispatch = useDispatch<AppDispatch>();
    const { user } = useSelector((state: any) => state.auth);
    const { deductions, loading } = useSelector((state: any) => state.payroll.deduction);
    const { earnings } = useSelector((state: any) => state.payroll.earning);
    const [formulaItems, setFormulaItems] = useState<{ name: string; operator: string }[]>([]);
    const [calculationType, setCalculationType] = useState('percentage');
    const [errors, setErrors] = useState({
        Name: '',
        CalculatedUpon: '',
        Percent: '',
        Amount: '',
        UnitOfCalculation: '',
        Description: '',
    });

    const resetForm = () => {
        setDeductionData({
            Name: '',
            CalculatedUpon: '',
            Percent: '',
            Amount: '',
            UnitOfCalculation: '',
            Description: '',
        });
        setFormulaItems([]);

        setErrors({
            Name: '',
            CalculatedUpon: '',
            Percent: '',
            Amount: '',
            UnitOfCalculation: '',
            Description: '',
        });
    };

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement> | any, field: string) => {
        const value = e.target ? e.target.value : e.value;
        setDeductionData({
            ...deductionData,
            [field]: value,
        });
        setErrors((prevErrors: any) => ({
            ...prevErrors,
            [field]: '',
        }));
    };

    const isEmpty = (v: any) => v === '' || v === null || v === undefined;

    useEffect(() => {
        if (!isModalVisible) return;

        const percentEmpty = isEmpty(deductionData?.Percent);
        const calcUponEmpty = isEmpty(deductionData?.CalculatedUpon);

        if (percentEmpty && calcUponEmpty) {
            setCalculationType('amount');  
        } else {
            setCalculationType('percentage');  
        }
    }, [isModalVisible, deductionData?.Percent, deductionData?.CalculatedUpon]);

    useEffect(() => {
        if (modalType === 'edit' && selectedRowData?.Formula) {
            const parsedFormula: { name: string; operator: string }[] = [];

            // Match all operators and names
            const regex = /([+-])\s*([\w\s]+)/g;
            let match;  
            while ((match = regex.exec(selectedRowData.Formula)) !== null) {
                parsedFormula.push({
                    operator: match[1],
                    name: match[2].trim(),
                });
            }

            setFormulaItems(parsedFormula);
        } else {
            setFormulaItems([]);
        }
    }, [modalType, selectedRowData]);

    const [isPercentage, setIsPercentage] = useState(false);
    const handleUnitSwitch = () => {
        setIsPercentage(!isPercentage);
    };

    const validateForm = () => {
        let formIsValid = true;
        let newErrors = { ...errors };

        if (!deductionData.Name) {
            formIsValid = false;
            newErrors.Name = 'Deduction name is required.';
        }

        if (calculationType === 'percentage' && !deductionData.CalculatedUpon) {
            formIsValid = false;
            newErrors.CalculatedUpon = 'Calculated Upon must be Required.';
        }

        if (calculationType === 'percentage') {
            if (!deductionData.Percent) {
                formIsValid = false;
                newErrors.Percent = 'Percentage is required.';
            } else if (isNaN(Number(deductionData.Percent))) {
                formIsValid = false;
                newErrors.Percent = 'Percentage must be a number.';
            } else if (Number(deductionData.Percent) < 0 || Number(deductionData.Percent) > 100) {
                formIsValid = false;
                newErrors.Percent = 'Percentage must be between 0 and 100.';
            }
        } else {
            if (!deductionData.Amount) {
                formIsValid = false;
                newErrors.Amount = 'Amount is required.';
            } else if (isNaN(Number(deductionData.Amount))) {
                formIsValid = false;
                newErrors.Amount = 'Amount must be a number.';
            }
        }

        setErrors(newErrors);
        return formIsValid;
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!validateForm()) {
            return;
        }
        const updatedFormData = {
            ...deductionData,
            // Formula: formulaItems.map(item => `${item.operator} ${item.name}`).join(' ').replace(/^\+/, '').trim(),
            Percent: calculationType === 'percentage' ? deductionData.Percent : null,
            Amount: calculationType === 'amount' ? deductionData.Amount : null,
            CreatedBy: modalType === 'create' ? user.UserId : undefined,
            ModifiedBy: modalType === 'edit' ? user.UserId : undefined,
        };
        try {
            let result;
            if (modalType === 'create') {
                console.log("executing")
                result = await dispatch(createDeduction(updatedFormData)).unwrap();

            } else if (modalType === 'edit') {
                if (selectedRowData) {
                    result = await dispatch(updateDeduction({ id: selectedRowData.Id, ...updatedFormData })).unwrap();
                }
            }
            if (result) {
                message.success(result.message);
                await dispatch(fetchDeductions());
                setTableKey((prevKey: any) => prevKey + 1);
                resetForm();
            } else {
                alert(result?.payload.error);
            }
            handleCancel();
        } catch (error: any) {
            const errorMessage = error?.error || 'An error occurred';
            message.error(errorMessage);
        }
    };
    const handleDeleteDeduction = async (id: number) => {
        try {
            const result = await dispatch(deleteDeduction(id));
            if (result.meta.requestStatus === 'fulfilled') {
                message.success(result.payload.message);
                await dispatch(fetchDeductions());
                setTableKey((prevKey: any) => prevKey + 1);
                setIsDeleteModalVisible(false);
            } else {
                message.warning(result.payload.error);
            }
        } catch (error) {
            message.error('Something went wrong');
        }
    };
    return (
        <>
            <Drawer
                title={modalType === "edit" ? "Edit Deduction" : "Add Deduction"}
                placement="right"
                width={600}
                onClose={() => {
                    handleCancel();  // Call the first function
                    resetForm();     // Call the second function
                }}
                visible={isModalVisible}
                style={{ marginTop: 50 }}
            >
                <form onSubmit={handleSubmit}>
                    <div className="modal-body pb-0">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="mb-3">
                                    <label className="form-label">
                                        Deduction Name <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="Name"
                                        value={deductionData.Name}
                                        onChange={(e) => handleInputChange(e, 'Name')}
                                    />
                                    {errors.Name && <div className="text-danger">{errors.Name}</div>}
                                </div>
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col-md-12">
                                <div className="form-check form-check-inline">
                                    <input
                                        type="radio"
                                        id="percentageRadio"
                                        name="calculationType"
                                        value="percentage"
                                        checked={calculationType === 'percentage'}
                                        onChange={() => setCalculationType('percentage')}
                                        className="form-check-input"
                                    />
                                    <label className="form-check-label" htmlFor="percentageRadio">
                                        Percentage
                                    </label>
                                </div>
                                <div className="form-check form-check-inline">
                                    <input
                                        type="radio"
                                        id="amountRadio"
                                        name="calculationType"
                                        value="amount"
                                        checked={calculationType === 'amount'}
                                        onChange={() => setCalculationType('amount')}
                                        className="form-check-input"
                                    />
                                    <label className="form-check-label" htmlFor="amountRadio">
                                        Absolute
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-6">
                                <label className="form-label">
                                    Calculated Upon <span className="text-danger">*</span>
                                </label>
                                <div className="mb-3">
                                    <select
                                        className="form-control"
                                        value={deductionData.CalculatedUpon}
                                        onChange={(e) => handleInputChange(e, 'CalculatedUpon')}
                                        disabled={calculationType === 'amount'}
                                    >
                                        <option value="">Select Calculated Upon</option>
                                        <option value="Basic">Basic</option>
                                        {deductions?.map((ded: any) => (
                                            <option key={ded.Id} value={ded.Name}>
                                                {ded.Name}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.CalculatedUpon && <div className="text-danger">{errors.CalculatedUpon}</div>}
                                </div>
                            </div>

                            {calculationType === 'percentage' ? (
                                <div className="col-md-6">
                                    <label className="form-label">
                                        Percentage <span className="text-danger">*</span>
                                    </label>
                                    <div className="mb-3">
                                        <input
                                            type="number"
                                            className="form-control"
                                            name="Percent"
                                            value={deductionData.Percent}
                                            onChange={(e) => handleInputChange(e, 'Percent')}
                                            step="0.01"
                                            placeholder="e.g., 40"
                                        />
                                        {errors.Percent && <div className="text-danger">{errors.Percent}</div>}
                                    </div>
                                </div>
                            ) : (
                                <div className="col-md-6">
                                    <label className="form-label">
                                        Amount <span className="text-danger">*</span>
                                    </label>
                                    <div className="mb-3">
                                        <input
                                            type="number"
                                            className="form-control"
                                            name="Amount"
                                            value={deductionData.Amount || ''}
                                            onChange={(e) => handleInputChange(e, 'Amount')}
                                            step="0.01"
                                            placeholder="e.g., 1000"
                                        />
                                        {errors.Amount && <div className="text-danger">{errors.Amount}</div>}
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* <div className="col-md-12">

                            <label className="form-label">
                                Formula{" "}
                                {formulaItems.length > 0 && (
                                    <span className="text-muted">
                                        : "<span className="text-primary">
                                            {formulaItems
                                                .map((item, index) =>
                                                    index === 0 ? item.name : `${item.operator} ${item.name}`
                                                )
                                                .join(' ')
                                                .trim()}
                                        </span>"
                                    </span>
                                )}
                            </label>
                            <div className="mb-3">
                                {formulaItems.map((item, index) => (
                                    <div key={index} className="d-flex align-items-center mb-2">
                                        <select
                                            className="form-select me-2"
                                            value={item.name}
                                            onChange={(e) => {
                                                const updated = [...formulaItems];
                                                updated[index].name = e.target.value;
                                                setFormulaItems(updated);
                                            }}
                                        >
                                            <option value="">Select</option>
                                            {earnings.map((ear: any) => (
                                                <option key={`ear-${ear.Id}`} value={ear.Name}>
                                                    {ear.Name} (Earning)
                                                </option>
                                            ))}
                                            {deductions.map((ded: any) => (
                                                <option key={`ded-${ded.Id}`} value={ded.Name}>
                                                    {ded.Name} (Deduction)
                                                </option>
                                            ))}
                                        </select>

                                        <select
                                            className="form-select w-auto"
                                            value={item.operator}
                                            onChange={(e) => {
                                                const updated = [...formulaItems];
                                                updated[index].operator = e.target.value;
                                                setFormulaItems(updated);
                                            }}
                                        >
                                            <option value="+">+</option>
                                            <option value="-">-</option>
                                        </select>

                                        <button
                                            type="button"
                                            className="btn btn-sm btn-outline-danger ms-2"
                                            onClick={() => {
                                                const updated = formulaItems.filter((_, i) => i !== index);
                                                setFormulaItems(updated);
                                            }}
                                        >
                                            ×
                                        </button>
                                    </div>
                                ))}

                                <button
                                    type="button"s
                                    className="btn btn-sm btn-outline-primary"
                                    onClick={() =>
                                        setFormulaItems([...formulaItems, { name: '', operator: '+' }])
                                    }
                                >
                                    + Add Item
                                </button>
                            </div>
                        </div> */}
                        {/* <div className="row">
                            <div className="col-md-12">
                                <label className="form-label">
                                    Unit of Calculation <span className="text-danger">*</span>
                                </label>
                                <div className="form-check form-switch">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        role="switch"
                                        id="unitOfCalculationSwitch"
                                        checked={isPercentage}
                                        onChange={handleUnitSwitch}
                                    />
                                    <label className="form-check-label" htmlFor="unitOfCalculationSwitch">
                                        Percentage Calculation
                                    </label>
                                </div>
                            </div>
                        </div> */}

                        {/* Conditionally render Unit input field if "Unit of Calculation" is checked */}
                        {isPercentage && (
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="mb-3 mt-2">
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="Unit"
                                            value={deductionData.UnitOfCalculation}
                                            onChange={(e) => handleInputChange(e, 'UnitOfCalculation')}
                                            placeholder="e.g., per month, per year"
                                        />
                                        {errors.UnitOfCalculation && (
                                            <div className="text-danger">{errors.UnitOfCalculation}</div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}

                        <div className="col-md-12">
                            <label className="form-label">
                                Description
                            </label>
                            <div className="mb-3">
                                <input
                                    type="text"
                                    className="form-control"
                                    name="Description"
                                    value={deductionData.Description}
                                    onChange={(e) => handleInputChange(e, 'Description')}
                                    placeholder="Description"
                                />
                                {errors.Description && <div className="text-danger">{errors.Description}</div>}
                            </div>
                        </div>
                    </div>

                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-white border me-2"
                            onClick={() => {
                                resetForm()
                                handleCancel()
                            }}
                        >
                            Cancel
                        </button>
                        <button type="submit" className="btn btn-primary" disabled={loading}
                            data-bs-dismiss={loading ? "" : "Modal"}>
                            {loading && <span className="spinner-border spinner-border-sm me-2" />}
                            {modalType === 'edit' ? 'Update Deduction' : 'Add Deduction'}
                        </button>
                    </div>
                </form>
            </Drawer >
            <DeleteModal1
                isVisible={isDeleteModalVisible}
                onClose={() => setIsDeleteModalVisible(false)}
                onConfirm={() => selectedRowData?.Id && handleDeleteDeduction(selectedRowData.Id)}
            />

        </>

    )
}

export default DeductionModal;